module.exports = __webpack_public_path__ + "img/key-words-2.1c8f721c.png";